module.exports = __webpack_public_path__ + "img/userphotonull.c419c645.png";